import React from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@digital-twins/design-system/components/ui/tooltip'

/**
 * The survey-tab hover SegmentBar uses when `hover="fast"`: a focusable
 * Radix tooltip at 150ms, and no native `title`. The child must be a DOM
 * node that can take a ref. An empty label returns that child unchanged.
 */
export interface FastTooltipProps {
  label?: string | null
  children: React.ReactElement
}

export function FastTooltip(props: FastTooltipProps) {
  const { label, children } = props

  if (!label) {
    return children
  }

  const trigger = React.cloneElement(children, {
    tabIndex: 0,
    'aria-label': label,
    title: undefined,
  })

  return (
    <TooltipProvider>
      <Tooltip delayDuration={150}>
        <TooltipTrigger asChild>{trigger}</TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
